import React from 'react';
import { EmbeddedPodlet } from '../../podlets/EmbeddedPodlet';
import { usePodlets } from '../../podlets/Podlets';

type SortingInfoProps = {
    className?: string;
};

export function SortingInfo(props: SortingInfoProps) {
    const { className } = props;

    const { sortingInfo } = usePodlets();

    return (
        <EmbeddedPodlet
            cautiouslyReloadScriptOnHydrationError
            className={className}
            response={sortingInfo}
        />
    );
}
